import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '../reducer'

const locationsStateSelector = (state: AppState) => state.locations

export const getLocationsSelector = createSelector(
  locationsStateSelector,
  ({ list }) => list?.slice().sort((a, b) => a.name.localeCompare(b.name)) || []
)

export const currentStatePropsSelector = createSelector(locationsStateSelector, ({ selectedState }) => {
  const { name, slug } = selectedState || {}
  return { name, slug }
})

export const loadingLocationsSelector = createSelector(locationsStateSelector, ({ locationsStatus }) => locationsStatus)
export const loadingStateSelector = createSelector(locationsStateSelector, ({ stateStatus }) => stateStatus)
export const loadingCitySelector = createSelector(locationsStateSelector, ({ cityStatus }) => cityStatus)

export const currentStateCitiesSelector = createSelector(
  locationsStateSelector,
  ({ selectedState }) => selectedState?.cities || []
)

export const currentCityPropsSelector = createSelector(locationsStateSelector, ({ selectedCity }) => {
  return selectedCity
})
